import { render, staticRenderFns } from "./claimNotice.vue?vue&type=template&id=28368457&scoped=true&"
import script from "./claimNotice.vue?vue&type=script&lang=js&"
export * from "./claimNotice.vue?vue&type=script&lang=js&"
import style0 from "./claimNotice.vue?vue&type=style&index=0&id=28368457&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28368457",
  null
  
)

export default component.exports